import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-370ca858")

_pushScopeId("data-v-370ca858")
const _hoisted_1 = { class: "time-swticher" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-left" })
], -1)
const _hoisted_3 = { class: "date" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-right" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: "button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emit('prev')))
    }, [
      _hoisted_2
    ]),
    _createVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createVNode("button", {
      class: "button",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emit('next')))
    }, [
      _hoisted_4
    ])
  ]))
})